const mxFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'MXN',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { mxFormats };
